import { Module } from "@/modules/centralWebsite/enums";
import type { RouteRecordRaw } from "vue-router";

export default <RouteRecordRaw[]>[
  {
    path: "/algemene-voorwaarden",
    name: "legal.terms",
    meta: {
      module: Module.Legal,
    },
    component: () =>
      import("@/modules/centralWebsite/legal/views/TermsAndConditionsView.vue"),
  },
  {
    path: "/privacy-verklaring",
    name: "legal.privacy",
    meta: {
      module: Module.Legal,
    },
    component: () =>
      import("@/modules/centralWebsite/legal/views/PrivacyPolicyView.vue"),
  },
];
